import { z } from 'zod';

export const Curve = {
    validator: z.array(
        z.object({
            time: z.number(),
            current: z.number(),
        }),
    ),
    units: { time: 's', current: 'A' } as const,
};

export type Curve = z.infer<typeof Curve.validator>;
